













import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { NuxtError } from '@nuxt/types'

import PageTransitionMixin from '@/mixins/transitions/page'

@Component
export default class LayoutError extends mixins(PageTransitionMixin) {
  @Prop(Object) error: NuxtError

  head() {
    return {
      title: this.$t('404.meta_title')
    }
  }
}
